const toggleSubMenuClass = (element, toggle) => {
  const parentElem = element.closest('.menu__item');
  parentElem?.classList.toggle('is-open-submenu', toggle);
};

// Toggle submenu on arrow click
attachEvent('.menu__arrow', 'click', (ev) => {
  const parentElem = ev.target.closest('.menu__item');
  if (!parentElem) return;
  if (windowWidth() < breakpointMd) {
    const isOpen = parentElem.classList.contains('is-open-submenu');
    toggleSubMenuClass(parentElem, !isOpen);
  }
  ev.preventDefault();
});

// Close submenu on back button click
attachEvent('.menu__back, [data-close-menu]', 'click', (ev) => {
  const parentElem = ev.target.closest('.menu__item');
  if (parentElem) {
    toggleSubMenuClass(parentElem, false);
  }
});

// Dropdown Edge Detection
const dropdowns = document.querySelectorAll('.menu__dropdown');

const updateDropdownEdge = (parent) => {
  const dropdownEle = parent.getBoundingClientRect();

  if (dropdownEle.right >= window.innerWidth) {
    parent.classList.add('is-touch-edge');
  } else {
    parent.classList.remove('is-touch-edge');
  }
};

const handleDropdownResize = debounce(() => {
  dropdowns.forEach((parent) => updateDropdownEdge(parent));
}, 150);

window.addEventListener('load', handleDropdownResize);
window.addEventListener('resize', handleDropdownResize);
